import React from 'react';
import PropTypes from 'prop-types';
import ApplicationLayout from 'Components/ApplicationLayout';
import ReportedSuspendedJockeys from './ReportedSuspendedJockeys';

const AsyncReportedSuspendedJockeys = props => {
  const pageConfig = {
    headerType: 'full',
    footerType: props.userAgent.device?.type === 'desktop' ? 'full' : 'mobile-none',
    navigationType: 'horse-racing',
    helmet: {
      bodyAttributes: {
        class: `${ props.userAgent.device?.type } bg-white`
      },
    }
  };

  return (
    <ApplicationLayout { ...pageConfig } { ...props }>
      <ReportedSuspendedJockeys { ...props } />
    </ApplicationLayout>
  );
};

AsyncReportedSuspendedJockeys.propTypes = {
  userAgent: PropTypes.object,
};

export default AsyncReportedSuspendedJockeys;